module.exports = __webpack_public_path__ + "img/img8.8f9fd8a4.jpg";